import React from 'react';

import { SearchAndFindGameCard } from './search-and-find-game-card';

export function SearchAndFindGameBoardSkeleton() {
  return (
    <div className='grid grid-cols-3 items-center gap-3'>
      {[...Array(12)].map((_, idx) => (
        <div className='relative size-24 animate-pulse cursor-pointer' key={`skeleton-tile-${idx}`}>
          <div className='h-2 w-2'>
            <div className='backface-hidden absolute flex h-full w-full items-center justify-center rounded-lg opacity-20'></div>
          </div>
        </div>
      ))}
    </div>
  );
}

interface SearchAndFindGameBoardProps {
  symbol: string;
  rotations: number[];
  uniqueSymbol: string;
  finishGame: () => void;
  setMoves: React.Dispatch<React.SetStateAction<number>>;
}

export function SearchAndFindGameBoard({
  symbol,
  rotations,
  uniqueSymbol,
  finishGame,
  setMoves,
}: SearchAndFindGameBoardProps) {
  const [guesses, setGuesses] = React.useState<Array<number>>([]);

  const symbolCount = rotations.length;
  const correctIdx = React.useMemo(() => Math.floor(Math.random() * symbolCount), [symbolCount]);

  const checkCompletion = React.useCallback(() => {
    if (guesses.includes(correctIdx)) {
      finishGame();
    }
  }, [correctIdx, finishGame, guesses]);

  const handleCardClick = React.useCallback(
    (idx: number) => {
      if (guesses.includes(correctIdx) || guesses.includes(idx)) {
        return;
      }
      setGuesses((prev) => [...prev, idx]);
      setMoves((moves) => moves + 1);
    },
    [correctIdx, guesses, setMoves],
  );

  React.useEffect(() => {
    checkCompletion();
  }, [checkCompletion]);

  return (
    <div className='grid grid-cols-3 items-center gap-3'>
      {rotations.map((deg, idx) => (
        <SearchAndFindGameCard
          isCorrectGuess={guesses.includes(idx) && idx === correctIdx}
          isGameOver={guesses.includes(correctIdx)}
          isIncorrectGuess={guesses.includes(idx) && idx !== correctIdx}
          key={`${symbol}-tile-${idx}`}
          onClick={() => handleCardClick(idx)}
          rotate={deg}
          tileCount={symbolCount}
          tileIndex={idx}
          use={idx === correctIdx ? uniqueSymbol : symbol}
        />
      ))}
    </div>
  );
}
